// wp-icons — Media & Audio (9)
import { createWpIcon } from './createIcon.js';

export const Play = createWpIcon('Play', [
  ['polygon', { points: '6 3 20 12 6 21 6 3', key: 'a' }],
]);
export const Pause = createWpIcon('Pause', [
  ['rect', { x: 6, y: 4, width: 4, height: 16, rx: 1, key: 'a' }],
  ['rect', { x: 14, y: 4, width: 4, height: 16, rx: 1, key: 'b' }],
]);
export const Mic = createWpIcon('Mic', [
  ['path', { d: 'M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z', key: 'a' }],
  ['path', { d: 'M19 10v2a7 7 0 0 1-14 0v-2', key: 'b' }],
  ['line', { x1: 12, x2: 12, y1: 19, y2: 22, key: 'c' }],
]);
export const MicOff = createWpIcon('MicOff', [
  ['line', { x1: 2, x2: 22, y1: 2, y2: 22, key: 'a' }],
  ['path', { d: 'M18.89 13.23A7.12 7.12 0 0 0 19 12v-2', key: 'b' }],
  ['path', { d: 'M5 10v2a7 7 0 0 0 12 5', key: 'c' }],
  ['path', { d: 'M15 9.34V5a3 3 0 0 0-5.68-1.33', key: 'd' }],
  ['path', { d: 'M9 9v3a3 3 0 0 0 5.12 2.12', key: 'e' }],
  ['line', { x1: 12, x2: 12, y1: 19, y2: 22, key: 'f' }],
]);
export const Volume1 = createWpIcon('Volume1', [
  ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5', key: 'a' }],
  ['path', { d: 'M15.54 8.46a5 5 0 0 1 0 7.07', key: 'b' }],
]);
export const Volume2 = createWpIcon('Volume2', [
  ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5', key: 'a' }],
  ['path', { d: 'M15.54 8.46a5 5 0 0 1 0 7.07', key: 'b' }],
  ['path', { d: 'M19.07 4.93a10 10 0 0 1 0 14.14', key: 'c' }],
]);
export const VolumeX = createWpIcon('VolumeX', [
  ['polygon', { points: '11 5 6 9 2 9 2 15 6 15 11 19 11 5', key: 'a' }],
  ['line', { x1: 22, x2: 16, y1: 9, y2: 15, key: 'b' }],
  ['line', { x1: 16, x2: 22, y1: 9, y2: 15, key: 'c' }],
]);
export const Camera = createWpIcon('Camera', [
  ['path', { d: 'M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z', key: 'a' }],
  ['circle', { cx: 12, cy: 13, r: 3, key: 'b' }],
]);
export const Image = createWpIcon('Image', [
  ['rect', { width: 18, height: 18, x: 3, y: 3, rx: 2, ry: 2, key: 'a' }],
  ['circle', { cx: 9, cy: 9, r: 2, key: 'b' }],
  ['path', { d: 'm21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21', key: 'c' }],
]);
